import { httpClientVendasCoreBff } from 'vendas-core/shared/services'
import { type WebhookCategory } from 'webhooks/shared/entities'

import { useQueryRequest } from '~/ui/hooks/utils'

export function useGetWebhookTypesCategories(paymentProfileId: string | undefined, options?: { enabled?: boolean }) {
  const { data: response, ...rest } = useQueryRequest<WebhookCategory[]>(
    ['useGetWebhookTypesCategories', paymentProfileId],
    () =>
      httpClientVendasCoreBff<WebhookCategory[]>({
        url: `/v1/payment-profile/${paymentProfileId}/webhooks/settings/types/categories`,
        method: 'GET'
      }),
    {
      enabled: Boolean(paymentProfileId) && (options?.enabled ?? true)
    }
  )

  return { data: response?.data, ...rest }
}
